import { render } from "./Customers.vue?vue&type=template&id=592a2738"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=592a2738&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__